import { render, staticRenderFns } from "./EditorHeader.vue?vue&type=template&id=412c6fb7&scoped=true&"
import script from "./EditorHeader.vue?vue&type=script&lang=js&"
export * from "./EditorHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412c6fb7",
  null
  
)

export default component.exports